import React, { Component, Fragment } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as authenticateActions from '../../actions/authenticateActions';
import { notify } from '../../util/notifications';
import { getPermissionByName } from '../../util/customMethods';
import { FormValidation } from "calidation";
import MfaLogin from './MfaLogin'; // Import the MFA login component

class Login extends Component { 
    constructor() {
        super();
        this.state = {
            userName: '',
            password: '',
            useMfa: false // New state to toggle between password and MFA login
        };
        this.onChangeValues = this.onChangeValues.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggleLoginMode = this.toggleLoginMode.bind(this);
    }    
    
    onChangeValues = (event) => {
        let _state = this.state;
        _state[event.currentTarget.name] = event.currentTarget.value;
        this.setState(_state);
    }  
    
    handleSubmit = (fields, errors, isValid) => {
        if (fields.isValid) {       
            const { dispatch, history } = this.props;
            dispatch(authenticateActions.authenticateUser(fields.fields.userName, fields.fields.password, (success) => {
                // Check individual permissions and navigate accordingly
                if (getPermissionByName('dashboard')) {
                    history.push('/dashboard');
                } else if (getPermissionByName('map')) {
                    history.push('/map');
                } else if (getPermissionByName('search')) {
                    history.push('/search');
                } else if (getPermissionByName('reports')) {
                    history.push('/ars-usage-report');
                } else if (getPermissionByName('towSheets')) {
                    history.push('/tow-sheets');
                } else {
                    history.push('/'); // Default fallback route
                }
            }, (error) => {
                notify.createNotification('error', 'Invalid UserName/Password', this.props.refNotify);
            }));
        } else {
            console.log("Please fill all the required fields", errors);
        }
    }
    
    toggleLoginMode = () => {
        this.setState(prevState => ({
            useMfa: !prevState.useMfa
        }));
    }
    
    render() {
        const { useMfa } = this.state;
        const config = {
            userName: {
                isRequired: "User name is required!",
                isEmail: "Valid emails only, please"
            },
            password: {
                isRequired: "Password field required!"
            }
        };
        
        return (
            <Fragment>
                <div className="col-lg-3 col-md-6 col-sm-8 col-xs-12 align-middle">
                    <div className="panel panel-default">
                        <p className="text-center mb-lg">
                            <br />
                            <a href="#">
                                <img src={require('../../assets/img/logo-2-white.png')} style={{height:'70px'}} alt="ACT" className="block-center img-rounded" />
                            </a>
                        </p>
                        <p className="text-center mb-lg">
                            <strong>SIGN IN TO CONTINUE.</strong>
                        </p>
                        
                        {useMfa ? (
                            // MFA Login Form
                            <MfaLogin 
                                refNotify={this.props.refNotify}
                                onSwitchLoginMode={this.toggleLoginMode}
                            />
                        ) : (
                            // Password Login Form
                            <div className="panel-body">                   
                                <FormValidation 
                                    name="frmLogin" 
                                    className="mb-lg" 
                                    config={config}
                                    onSubmit={this.handleSubmit}
                                >
                                    {({ fields, errors, submitted }) => (
                                        <Fragment>
                                            <div className={(submitted && errors.userName) ? "form-group has-feedback has-error has-danger" : "form-group has-feedback"}>
                                                <input 
                                                    id="userName" 
                                                    name="userName" 
                                                    type="text" 
                                                    placeholder="Enter User name" 
                                                    className="form-control" 
                                                    value={fields.userName} 
                                                    onChange={this.onChangeValues}
                                                />
                                                <span className="fa fa-envelope form-control-feedback text-muted"></span>
                                                {(submitted && errors.userName) ? 
                                                    <div className="invalid-feedback with-errors">
                                                        <span className="text-danger">{errors.userName}</span>
                                                    </div>
                                                : null}
                                            </div>
                                            
                                            <div className={(submitted && errors.password) ? "form-group has-feedback has-error has-danger" : "form-group has-feedback"}>
                                                <input 
                                                    id="password" 
                                                    name="password" 
                                                    type="password" 
                                                    placeholder="Password" 
                                                    className="form-control" 
                                                    value={fields.password} 
                                                    onChange={this.onChangeValues}
                                                />
                                                <span className="fa fa-lock form-control-feedback text-muted"></span>
                                                {(submitted && errors.password) ? 
                                                    <div className="invalid-feedback with-errors">
                                                        <span className="text-danger">{errors.password}</span>
                                                    </div>
                                                : null}
                                            </div>
                                            
                                            <div className="clearfix">
                                                <div className="checkbox c-checkbox pull-left mt0">
                                                    <label>
                                                        <input type="checkbox" value="" />
                                                        <span className="fa fa-check"></span>Remember Me
                                                    </label>
                                                </div>
                                                <div className="pull-right">
                                                    <Link to="/forgetPwd" className="text-muted">Forgot your password?</Link>
                                                </div>
                                            </div>
                                            
                                            <button type="submit" className="btn btn-block btn-primary">Login</button>
                                            
                                            <div className="text-center mt-3">
                                                <Link to="#" onClick={this.toggleLoginMode} className="text-muted">
                                                    Use MFA Login
                                                </Link>
                                            </div>
                                        </Fragment>
                                    )}
                                </FormValidation>
                            </div>
                        )}
                    </div>
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        authInfo: state.authInfo,
        refNotify: state.refNotify
    }
};
 
export default withRouter(connect(mapStateToProps)(Login));